import { ApiCall } from '~/adapters/services/shared/apiCall';
import { useAccountsApiCall } from '~/adapters/services/accounts/accountsApiCall';
import { useMemo } from 'react';
import { BraintreeToken } from './types';

class BraintreeRepository {
    constructor(private readonly accountsApiCall: ApiCall) {}

    public getBraintreeToken = async (accountId: number): Promise<BraintreeToken> => {
        const response = await this.accountsApiCall<BraintreeToken>(`/accounts/${accountId}/vault/braintree/token`);
        return response.data;
    };
}

export const useBraintreeRepository = () => {
    const accountsApiCall = useAccountsApiCall();

    return useMemo(() => new BraintreeRepository(accountsApiCall), []);
};
